import { axiosClient } from "../request";

export const adminLogin = async (method, module, data) => {
  const response = axiosClient[method](module, data);
  return response;
};
